<template>
  <DefaultLayout>
    <div ref="topdiv">
      <img v-lazy="getPhoto" class="img-fluid" />
      <div class="text-center">
        <br />
        <h4>{{ $t('lobby') }}</h4>
      </div>
      {{ $t('pleasewait') }}
    </div>
    <br />

    <b>{{ $t("players", { n: joinedPlayerCount }) }}</b>

    <div>
      <span
        v-for="(player, index) in $store.getters.getPlayers"
        :key="player.id"
      >
        {{ player.nick_name }}<span v-if="index < joinedPlayerCount - 1">,</span>
      </span>
    </div>

  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import { } from "@/services/APIService";
import { mapGetters } from "vuex";
import { convertPhotoToAmazonURL } from "@/services/utils";

export default {
  components: { DefaultLayout },
  watch: {
    getGameOpen: {
      handler(newData, oldData) {
        this.startGameIfOpen();
      },
    },
  },
  data: function () {
    return {};
  },
  async created() {
    this.$store.dispatch("connectNotification");
    this.$store.dispatch("updateGame");
    this.startGameIfOpen();
  },
  computed: {
    ...mapGetters(["getGameOpen"]),
    joinedPlayerCount() {
      return this.$store.getters.getPlayers.length;
    },
    getPhoto() {
      if (this.$store.getters.getRPSScenarioInCurrentLocale.lobby_photo) {
        return convertPhotoToAmazonURL(this.$store.getters.getRPSScenarioInCurrentLocale.lobby_photo);
      } else {
        return "/placeholder.png";
      }
    },
  },
  methods: {
    startGameIfOpen() {
      if (this.$store.state.main.game.open) {
        this.$router.push("/rps/begin");
      }
    },
  },
};
</script>

<i18n>
{
  "en": {
    "lobby": "Lobby",
    "pleasewait": "Please wait for the other players to join the simulation. The facilitator will open the simulation when it's about to start.",
    "players": "Joined players (total {n}):"
  },
  "fi": {
    "lobby": "Aula",
    "pleasewait": "Odotetaan muiden pelaajien liittymistä simulaatioon. Pelinjohtaja avaa simulaation, kun kaikki ovat valmiita aloittamaan.",
    "players": "Liittyneet pelaajat (yhteensä {n}):"
  },
  "sv": {
    "lobby": "Lobby",
    "pleasewait": "Vänta tills de andra spelarna går med i simuleringen. Handledaren kommer att öppna simuleringen när den ska börja.",
    "players": "Anslutna spelare (totalt {n}):"
  },
 "de": {
    "lobby": "Empfangshalle",
    "pleasewait": "Bitte warten Sie, bis die anderen Spieler der Simulation beitreten. Der Moderator öffnet die Simulation kurz vor dem Start.",
    "players": "Beigetretene Spieler (insgesamt {n}):"
  },
  "ko": {
    "lobby": "로비",
    "pleasewait": "다른 플레이어가 시뮬레이션에 참여할 때까지 기다려 주십시오. 진행자는 시뮬레이션이 시작되려고 할 때 시뮬레이션을 엽니다.",
    "players": "참가 선수 (총 {n}명):"
  }  
}
</i18n>
